import apiClient from '../apiClient';

const recruitmentAnalyticsService = {
  // Get recruitment analytics overview
  getOverview: async (period = '30d', department = 'all') => {
    try {
      const response = await apiClient.get('/recruitment/analytics/overview', {
        params: { period, department }
      });
      return response.data || response;
    } catch (error) {
      
      throw new Error(error.response?.data?.responseMessage || error.message || 'Failed to fetch recruitment overview');
    }
  },

  // Get recruitment funnel metrics from backend analytics funnel endpoint
  getFunnelMetrics: async (period = '30d', department = 'all', jobId, search, startDate, endDate) => {
    try {
      const params = { period, department };
      if (jobId) params.jobId = jobId;
      if (search) params.search = search;
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;

      const response = await apiClient.get('/recruitment/analytics/funnel', { params });
      return response.data?.data || response.data || {};
    } catch (error) {
      
      throw new Error(error.response?.data?.responseMessage || 'Failed to fetch funnel metrics');
    }
  },

  // Get time metrics
  getTimeMetrics: async (period = '30d', department = 'all') => {
    try {
      const response = await apiClient.get('/recruitment/analytics/time-metrics', {
        params: { period, department }
      });
      return response.data;
    } catch (error) {
      
      throw new Error(error.response?.data?.responseMessage || 'Failed to fetch time metrics');
    }
  },

  // Get cost metrics
  getCostMetrics: async (period = '30d', department = 'all') => {
    try {
      const response = await apiClient.get('/recruitment/analytics/cost-metrics', {
        params: { period, department }
      });
      return response.data;
    } catch (error) {
      
      throw new Error(error.response?.data?.responseMessage || 'Failed to fetch cost metrics');
    }
  },

  // Get source effectiveness
  getSourceEffectiveness: async (period = '30d', department = 'all', startDate, endDate) => {
    try {
      const response = await apiClient.get('/recruitment/analytics/source-effectiveness', {
        params: { period, department, startDate, endDate }
      });
      return response.data;
    } catch (error) {
      
      throw new Error(error.response?.data?.responseMessage || 'Failed to fetch source effectiveness');
    }
  },

  // Get department metrics
  getDepartmentMetrics: async (period = '30d', startDate, endDate) => {
    try {
      const response = await apiClient.get('/recruitment/analytics/department-metrics', {
        params: { period, startDate, endDate }
      });
      return response.data;
    } catch (error) {
      
      throw new Error(error.response?.data?.responseMessage || 'Failed to fetch department metrics');
    }
  },

  // Get recent activity
  getRecentActivity: async (limit = 10) => {
    try {
      const response = await apiClient.get('/recruitment/analytics/recent-activity', {
        params: { limit }
      });
      return response.data;
    } catch (error) {
      
      throw new Error(error.response?.data?.responseMessage || 'Failed to fetch recent activity');
    }
  },

  // Get available departments
  getDepartments: async () => {
    try {
      const response = await apiClient.get('/hr/departments');
      

      if (response.data && response.data.departments) {
        // Extract department names from the response
        const departmentNames = response.data.departments.map(dept => dept.name);
        return ['all', ...departmentNames];
      } else if (response.data && Array.isArray(response.data)) {
        // If data is directly an array
        const departmentNames = response.data.map(dept => dept.name);
        return ['all', ...departmentNames];
      } else {
        // Fallback to default departments
        return ['all', 'engineering', 'sales', 'marketing', 'hr', 'operations'];
      }
    } catch (error) {
      
      // Return default departments on error
      return ['all', 'engineering', 'sales', 'marketing', 'hr', 'operations'];
    }
  },

  // Export analytics report
  exportReport: async (period = '30d', department = 'all', format = 'csv') => {
    try {
      const response = await apiClient.post('/recruitment/analytics/export', {
        period,
        department,
        format
      }, {
        responseType: format === 'csv' ? 'blob' : 'json'
      });
      return response.data;
    } catch (error) {
      
      throw new Error(error.response?.data?.responseMessage || 'Failed to export report');
    }
  }
};

export default recruitmentAnalyticsService;
